import {
  ChangeDetectorRef,
  Directive,
  Input,
  OnDestroy,
  ViewContainerRef,
} from '@angular/core';
import { MODULE_DEFINITION_MAP } from '../definitions/module.definitions';
import { ModuleBaseComponent } from '../components/module-base/module-base.component';
import { StrapiComponent } from 'src/app/shared/models/components/strapi-component';

@Directive({
  selector: '[appModuleContainer]',
})
export class ModuleContainerDirective implements OnDestroy {
  private moduleInstance?: ModuleBaseComponent<unknown>;

  private _strapiComponentType?: string;
  @Input('appModuleContainer') public set strapiComponent(
    value: StrapiComponent | undefined,
  ) {
    const oldType = this._strapiComponentType;
    if (
      value &&
      typeof value.__component === 'string' &&
      oldType !== value.__component
    ) {
      this.viewContainer.clear();
      this.loadModule(value.__component, value);
      this._strapiComponentType = value.__component;
      return;
    }
    // If the component type hasn't changed, just update data without clearing the view
    if (value) {
      this.moduleInstance?.bindData(value);
    } else {
      // If value becomes undefined, clear the view
      this.viewContainer.clear();
    }
  }

  constructor(
    private readonly viewContainer: ViewContainerRef,
    private readonly changeDetector: ChangeDetectorRef,
  ) {}

  ngOnDestroy(): void {
    this.viewContainer.clear();
  }

  private async loadModule(
    strapiComponentType: string,
    data: StrapiComponent,
  ): Promise<void> {
    const moduleDef = MODULE_DEFINITION_MAP.get(strapiComponentType);

    if (!moduleDef) {
      throw new Error(`Module with ID "${strapiComponentType}" not found.`);
    }

    const compType = await moduleDef.load();
    this.moduleInstance =
      this.viewContainer.createComponent<ModuleBaseComponent<unknown>>(
        compType,
      ).instance;
    this.moduleInstance.bindData(data);
    this.changeDetector.markForCheck();
  }
}
